import React from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import WindowTitlebar from './components/WindowTitlebar';
import './index.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
    const msg = String(error?.message || '');
    const name = String(error?.name || '');
    const isChunkError =
      /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(msg) ||
      name === 'ChunkLoadError';
    if (isChunkError && !sessionStorage.getItem('chunk-error-reloaded')) {
      sessionStorage.setItem('chunk-error-reloaded', '1');
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh', gap: 16,
          fontFamily: 'system-ui, sans-serif', background: '#f9fafb',
        }}>
          <div style={{ fontSize: 32 }}>⚠️</div>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', maxWidth: 320, textAlign: 'center' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8, padding: '8px 20px', borderRadius: 8,
              background: '#0f766e', color: '#fff', border: 0,
              fontSize: 14, fontWeight: 600, cursor: 'pointer',
            }}
          >
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AuthProvider>
          <WindowTitlebar />
          <AppRoutes />
        </AuthProvider>
      </Provider>
    </ErrorBoundary>
  );
}
